export default __webpack_public_path__ + "static/media/logo-ak.a1770dd7.svg";